import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'

const prettyNamePrint = (name: Nullable<string>) => startCase(toLower(name || ''))

export default prettyNamePrint
